import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for J5M1 (Sample Request Reversal)
// ============================================================

export interface WriteoffItem {
  fj110_01: string;         // Request no (PK)
  fj110_11: string;         // Request date (formatted string)
  fj110_12: string;         // Customer name (lookup)
  fj110_21: string;         // Salesperson name (lookup)
  fj110_22: string;         // Department name (lookup)
  cust_code: string;        // Customer code (original)
  sales_code: string;       // Salesperson code (original)
  dept_code: string;        // Department code (original)
}

export interface QueryResponse {
  items: WriteoffItem[];
  total: number;
}

export interface ExecuteResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const j5m1Api = {
  /** Query sample request items within a range */
  async query(startNo: string, endNo: string): Promise<QueryResponse> {
    const res = await apiClient.post('/api/j5m1/query', {
      start_no: startNo,
      end_no: endNo,
    });
    return res.data;
  },

  /** Execute batch writeoff for selected items */
  async execute(requestNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/j5m1/execute', {
      request_nos: requestNos,
      confirmed: true,
    });
    return res.data;
  },
};
